module.exports = __webpack_public_path__ + "assets/img/100607.09d7810f.png";